import * as React from 'react';
import * as Yup from 'yup';

import { Link as RouterLink, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';

import InputAdornment from '@mui/material/InputAdornment';
// icons
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
//import { useSnackbar } from 'notistack';

import useAuth from '../hooks/useAuth';
import useIsMountedRef from '../hooks/useIsMountedRef';
// utils
import axios from "../utils/axios";


const theme = createTheme();

export default function ResetPasswordForm() {
    const isMountedRef = useIsMountedRef();
    const [alertError, setAlertError] = React.useState('');
    const [alertMessage, setAlertMessage] = React.useState('');

    const { otpCode } = useParams();

    const resetAlerts = () => {
        setAlertError('');
        setAlertMessage('');
    }
  
    const ResetSchema = Yup.object().shape({
        otpCode: Yup.string()
            .required('Codice OTP obbligatorio.'),
        password: Yup.string()
            .required('Password obbligatoria.'),
        confirmPassword: Yup.string()
            .required('Conferma password obbligatoria.')
            .oneOf([Yup.ref('password'), null], 'Le password non corrispondono.'),
    });
  
    const formik = useFormik({
        initialValues: {
            otpCode: otpCode,
            password: '',
            confirmPassword: '',
        },
        validationSchema: ResetSchema,
        onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
            try {
                resetAlerts();
                const response = await axios.post(`/password/reset`, { otp_code: values.otpCode, password: values.password, password_confirmation: values.confirmPassword });
    
                if (response.data.success) {
                    setAlertMessage(response.data.message + " Eseguo il redirect alla pagina di login...");

                    setInterval(() => {
                        window.location.href = '/auth/login';
                    }, 3000);
                }
            } catch (error) {
                console.error(error);

                if (error.status === 422) {
                    setAlertError('Invalid parameters');
                } else {
                    setAlertError(error.data.message);
                }

                if (isMountedRef.current) {
                    resetForm({
                        values: {
                            otpCode: '',
                            password: '',
                            confirmPassword: '',
                        },
                    });

                    setSubmitting(false);
                }
            }
        }
    });

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (

      <Container component="div">
        <CssBaseline />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >

            <Typography component="h1" variant="h4" sx={{ color: '#004990', fontWeight: 'bold' }}>
                Reset Password
            </Typography>

            <form onSubmit={formik.handleSubmit} style={{minWidth: "100%"}}>
                    {/* {errors.afterSubmit && <Alert severity="error" sx={{mt: 2, mb: 1}}>{errors.afterSubmit}</Alert>} */}
                {alertError && <Alert severity="error" sx={{mt: 2, mb: 1}}>{alertError}</Alert>}
                {alertMessage && <Alert severity="success" sx={{mt: 2, mb: 1}}>{alertMessage}</Alert>}

                <TextField
                    margin="normal"
                    variant="standard"
                    
                    fullWidth
                    id="otpCode"
                    placeholder="Codice Otp"
                    name="otpCode"
                    autoComplete="otpCode"
                    autoFocus
                    value={formik.values.otpCode}
                    onChange={formik.handleChange}
                    error={formik.touched.otpCode && Boolean(formik.errors.otpCode)}
                    helperText={formik.touched.otpCode && formik.errors.otpCode}
                    sx={styles.otpInput}

                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <VpnKeyOutlinedIcon sx={{ color: "#6369E9" }} />
                            </InputAdornment>
                        ),
                        disableUnderline: true,
                    }}
                />

                <TextField
                    margin="normal"
                    variant="standard"
                    
                    fullWidth
                    id="password"
                    placeholder="Password"
                    name="password"
                    autoComplete="password"
                    autoFocus
                    type="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={formik.touched.password && Boolean(formik.errors.password)}
                    helperText={formik.touched.password && formik.errors.password}
                    sx={styles.inputText}

                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <LockOutlinedIcon sx={{ color: "#6369E9" }} />
                            </InputAdornment>
                        ),
                        disableUnderline: true,
                    }}
                />

                <TextField
                    margin="normal"
                    variant="standard"
                    
                    fullWidth
                    id="confirmPassword"
                    placeholder="Conferma Password"
                    name="confirmPassword"
                    autoComplete="confirmPassword"
                    autoFocus
                    type="password"
                    value={formik.values.confirmPassword}
                    onChange={formik.handleChange}
                    error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                    helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                    sx={styles.inputText}

                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <LockOutlinedIcon sx={{ color: "#6369E9" }} />
                            </InputAdornment>
                        ),
                        disableUnderline: true,
                    }}
                />

                <Stack direction="column" justifyContent="center" spacing={3} sx={{ mt: 4, p: "0 25%", textAlign: "center" }}>
                    <Button
                        type="submit"
                        variant="contained"
                        sx={{ p: '8px 50px', backgroundColor: '#2CA4DE' }}
                    >
                        Reset
                    </Button>

                    <Link href="/auth/password/request" variant="body2">
                        Richiedi nuova password
                    </Link>
                </Stack>
            </form>
          </Box>

      </Container>
  );
}

const styles = {
  inputText: {
    backgroundColor: '#EEF2F6',
    border: '0px solid',
    p: '1rem',
    borderRadius: '10px',
  },
  otpInput: {
    backgroundColor: '#EEF2F6',
    border: '0px solid',
    p: '1rem',
    borderRadius: '10px',
    display: "none"
  },
}